/* eslint-disable @typescript-eslint/no-throw-literal */
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { IEchocardiogramTest, IFetchEchocardiogramTest } from '~/interfaces'
import { HttpStatusCode } from '~/protocols/http'
import { fetchEchocardiogramTest, message } from '~/services'

const UNIQUE_KEY = 'echocardiogramTest'

export const useFetchEchocardiogramTest = (
  fetchParams: IFetchEchocardiogramTest | null,
  config?: UseQueryOptions<IEchocardiogramTest, Error, IEchocardiogramTest>
): UseQueryResult<IEchocardiogramTest, Error> => {
  const fetcher = async () => {
    if (!fetchParams) throw new Error('fetchParams is required')

    try {
      const response = await fetchEchocardiogramTest(fetchParams)
      return response
    } catch (error) {
      const axiosError = error as AxiosError

      if (axiosError?.code === String(HttpStatusCode.notFound)) {
        throw new Error(message('detailsMedicalEvents.emptyResponseFetched'))
      }

      throw new Error(message('messages.genericUnexpectedError'))
    }
  }

  return useQuery<IEchocardiogramTest, Error>([UNIQUE_KEY, fetchParams?.pathParams], fetcher, {
    cacheTime: Infinity,
    staleTime: Infinity,
    enabled: !!fetchParams,
    ...config
  })
}
